import { css } from '@emotion/css';

export const defaultRecentCowStanzoneSlidesStyles = {
  root: css`
    padding-left: 20px;
    padding-right: 20px;
  `,
  itemRoot: css`
    display: flex;
    margin-top: 8px;
    /* align-items:  */
  `,
  image: css`
    flex: 1;
    width: 50%;
    margin-top: 12px;
  `,
  camName: css`
    flex: 1;
  `,
} as const;
